import React, { useState, useEffect } from 'react';
import css from './HeroBanner.module.scss';
import { Sun, CheckCircle, PlusCircle, Clock, Calendar } from 'lucide-react';
import { IconMorning, IconAfternoon, IconEvening } from "re_redesigned_componnents/icon";
// import bannerBg from '../../assets/images/bannertrainer.png';
// import bannerBg from "../../assets/images/bannertrainer.png"
import bannerBg from "../../assets/images/bannertrainer.png"
import { Link } from 'react-router-dom';

const HeroBanner = ({ name = "Arjun", addRedirection }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 60000);
    return () => clearInterval(timer);
  }, []);

  const hrs = currentTime.getHours();
  const greetingText = hrs < 12 ? 'Good morning' : hrs < 17 ? 'Good afternoon' : 'Good evening';
  const GreetingIcon = hrs < 12 ? <IconMorning /> : hrs < 17 ? <IconAfternoon /> : <IconEvening />;

  const carouselItems = [
    {
      id: 1,
      type: 'upcoming',
      title: 'Physics - Class-X-A',
      chapter: 'Chapter 5: Work, Energy & Power',
      time: '02:30 - 03:30 PM',
      day: 'Today',
      statusLabel: 'UPCOMING CLASS'
    },
    {
      id: 2,
      type: 'live',
      title: 'Advanced React Class-XII-A',
      chapter: 'Hooks Deep Dive',
      time: '04:00 - 05:00 PM',
      day: 'Today',
      statusLabel: 'LIVE SESSION'
    },
    {
      id: 3,
      type: 'upcoming',
      title: 'PTA Meeting - Class-XII-A',
      chapter: 'PTA- Meeting',
      time: '02:00 - 03:30 PM',
      day: 'Tomorrow',
      statusLabel: 'UPCOMING EVENT'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [carouselItems.length]);

  return (
    <div className={css.hero_banner} style={{ backgroundImage: `url(${bannerBg})` }}>
      <div className={css.overlay}></div>
      <div className={css.carousel_bg_container}>
        {carouselItems.map((item, index) => (
          <div
            key={item.id}
            className={css.full_slide}
            style={{
              opacity: currentSlide === index ? 1 : 0,
              transform: `translateX(${(index - currentSlide) * 100}%)`,
            }}
          >
            <div className={css.slide_content_right}>
              <div className={css.meeting_card}>
                <div className={item.type === 'live' ? css.status_live : css.status_next}>
                  {item.type === 'live' && <span className={css.dot}></span>}
                  {item.statusLabel}
                </div>
                <h3 className={css.meeting_title}>{item.title}</h3>
                <p className={css.meeting_host}>{item.chapter}</p>
                <div className={css.meeting_time}>
                  <span><Clock size={14} /> {item.time}</span>
                  <span><Calendar size={14} /> {item.day}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={css.static_layer}>
        <div className={css.content_left}>
          <div className={css.greeting_chip}>
            <span className={css.sparkle}>{GreetingIcon}</span> {greetingText.toUpperCase()}, MR. {name.toUpperCase()}
          </div>

          <h1 className={css.main_heading}>
            Welcome back, Mr. {name}!
          </h1>

          <p className={css.sub_text}>
            You're doing great this month.
          </p>

          <ul className={css.statsList}>
            <li>5 classes today</li>
            <li>87% class completion</li>
            <li>24 assignments pending review</li>
          </ul>

          <div className={css.action_buttons}>
            <Link to="/Attendance-Record" className={css.primary_btn}>
              <CheckCircle size={16} /> Mark Attendance
            </Link>
            <Link to="/create-test" className={css.primary_btn} style={{ backgroundColor: '#f1f5f9', color: '#0f172a' }}>
              <PlusCircle size={16} /> Create Assessment
            </Link>
          </div>
        </div>

        <div className={css.dots_wrapper}>
          <div className={css.carousel_dots}>
            {carouselItems.map((_, idx) => (
              <span
                key={idx}
                className={`${css.dot_nav} ${currentSlide === idx ? css.active : ''}`}
                onClick={() => setCurrentSlide(idx)}
              ></span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
